export default "__VITE_ASSET__XYd8YUbC__"